var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountInactive = function SvgAccountInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 5,
    fill: "#D6E5F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B2C9DE",
    d: "M3 18a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v3H3v-3Z"
  })));
};
export default SvgAccountInactive;